import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2 8.69922L8 2.69922L9.40039 4.09961L4.79981 8.69922L9.40039 13.2998L8 14.6992L2 8.69922ZM9 8.7002L15 2.7002L16.4004 4.09961L11.7998 8.7002L16.4004 13.2998L15 14.7002L9 8.7002Z" })
});
export default SvgDoubleArrowLeft;
